type BrowserRouteAuthority = Pick<Window, "history" | "location">;

export function replaceAuthenticatedLoginRoute(
  browser: BrowserRouteAuthority,
): string {
  const destination = `/studio${browser.location.search}${browser.location.hash}`;
  browser.history.replaceState(null, "", destination);
  return destination;
}
